import React from 'react';
import './main-loading-style.css';
import Svg from '../icons/svg';

function MainLoading() {
  return (
    <div className={'main-loading all-center'}>
      <Svg name={'mainLogo'} fill={'#b0b0b0'} width={45} label={'Loading ...'} />
    </div>
  );
}

export default MainLoading;
